import type { FormStep5Customer, FormStep5CustomerResponse } from "@/types/Form";
import Api from "./Api";

export class CustomerApi {
  static async createOne(customerData: FormStep5Customer) {
    const { data } = await Api.post<FormStep5CustomerResponse>("/customer/", customerData);
    return data;
  }

  static async getOne(customerId: string) {
    const { data } = await Api.get<FormStep5CustomerResponse>(`/customer/${customerId}/`);
    return data;
  }

  static async updateOne(customerId: string, customerData: FormStep5Customer) {
    const { data } = await Api.put<FormStep5CustomerResponse>(
      `/customer/${customerId}/`,
      customerData,
    );
    return data;
  }
}
